<template lang="pug">
div
  .card
    .container-fluid
      .row
        .col-md-12
          .white-box
            h1.box-title.m-b-0 トップページレイヤー編集
            p.text-muted.m-b-30.font-13 SWAN Proサイトのトップページレイヤー編集画面
            h3.box-title レイヤー一覧
            WorkList(apiname='top_layer',editPath='layer/edit')
            router-link(to='layer/edit')
              el-button.col-md-12(type='primary', icon='el-icon-edit') 新規登録
</template>

<script>
import WorkList from '@/views/components/swan/common/List'
export default {
  name: 'LayerList',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: {
    WorkList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/layer/list.vue